/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Gratitude_Body1Inputs */

const en_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back when Forest was just a sapling,
thank you for supporting our Pro version.`)
};

const ar_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في الوقت الذي كانت فيه Forest مجرد شتلة صغيرة،
شكرًا لدعمك لإصدار النسخة الا احترافي الخاصة بنا.`)
};

const de_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damals, als Forest noch ein Pflänzchen war, danken wir Ihnen für die Unterstützung unserer Version Pro .`)
};

const es_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando Forest era solo un retoño,
gracias por apoyar nuestra versión Pro.`)
};

const fr_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque Forest n'était encore qu'une jeune pousse, merci d'avoir soutenu notre version Pro.`)
};

const it_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando Forest era solo un alberello, 
grazie per aver supportato la nostra versione Pro.`)
};

const ja_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forestがまだ小さな芽だったころから、
Pro版を支えてくださりありがとうございました。`)
};

const ko_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest가 아직 새싹에 불과했을 때 
Pro 버전을 지원해 주셔서 감사드려요.`)
};

const pt_br_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agradecemos por apoiar nossa versão Pro
quando o Forest ainda era apenas uma mudinha.`)
};

const ru_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасибо, что поддерживали нашу версию Pro, когда в Forest были только молодые побеги.`)
};

const th_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตั้งแต่วันที่ Forest ยังเป็นแค่เพียงต้นกล้า
ขอบคุณสำหรับการสนับสนุนเวอร์ชันโปรของเรา`)
};

const tr_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest henüz bir fidanken, Pro versiyonumuzu desteklediğiniz için teşekkür ederiz.`)
};

const zh_cn_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Forest 还是一株幼苗时，
谢谢你曾付费支持 Forest 专业版`)
};

const zh_tw_pro_user_appreciation_letter_gratitude_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Forest 還是一株幼苗時，
謝謝你曾付費支持 Forest 專業版`)
};

/**
* | output |
* | --- |
* | "Back when Forest was just a sapling, thank you for supporting our Pro version." |
*
* @param {Pro_User_Appreciation_Letter_Gratitude_Body1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_gratitude_body1 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Gratitude_Body1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Gratitude_Body1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_gratitude_body1(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_gratitude_body1(inputs)
	return zh_tw_pro_user_appreciation_letter_gratitude_body1(inputs)
});